import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const Response = z.object({
    methodId: z.string().brand("StytchMethodId"),
});
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/identity/authentication/email/mfa/sms/send"
    : "https://middleware.uat.farther.com/identity/authentication/email/mfa/sms/send";
/**
 *
 * @param email email of the user in the farther portal
 * @param devEmail email of the user in stytch (only allowed in UAT)
 * @returns
 */
export const sendMFASms = async (email, devEmail) => {
    const res = await axios.post(url(), { email, devEmail }, {
        headers: {
            Version: "20240529",
            Authorization: `Bearer none`,
            "idempotency-key": `${new Date().toISOString()}-${email}-${devEmail ?? "<no devEmail>"}`,
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[sendMFASms] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default sendMFASms;
//# sourceMappingURL=sendMFASms.js.map